import { CloseIcon as Close } from "@l2r-front/l2r-icons"
import {
    Box as UiBox,
    FileViewer as UiFileViewer,
    IconButton as UiIconButton,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

import { DocumentInfo as L2RDocumentInfo } from "../DocumentInfo"

export const Box = styled(UiBox, { shouldForwardProp: (prop) => !["isMobile", "height", "interactive"].includes(prop) })(({ theme, isMobile }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    borderRadius: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    bottom: isMobile ? "5%" : 0,
    top: isMobile ? "5%" : 0,
    left: isMobile ? "5%" : 0,
    right: isMobile ? "5%" : 0,
    margin: "auto",
    maxHeight: !isMobile ? "90%" : "",
    minHeight: !isMobile ? "55%" : "",
    height: "80%",
    width: "90%",
    padding: isMobile ? theme.spacing(6, 6, 6, 6) : theme.spacing(8, 8, 8, 8),
    position: "absolute",
    overflow: "hidden",
}))

export const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "top",
    marginBottom: theme.spacing(6),
    width: "100%",
}))

export const TypeIcon = styled("img")(({ theme }) => ({
    height: 28,
    width: 28,
    marginRight: theme.spacing(3),
}))

export const Title = styled(Typography)(() => ({
    textAlign: "left",
}))

export const IconButton = styled(UiIconButton)(() => ({
    padding: 0,
    marginLeft: "auto",
}))

export const FormContainer = styled("div")({
    flex: "1 1 auto",
})

export const CloseIcon = styled(Close)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
    height: 24,
    width: 24,
}))

export const Content = styled("div")(() => ({
    position: "relative",
    flex: 1,
    minHeight: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}))

export const FileViewer = styled(UiFileViewer)(() => ({
    height: "100%",
    width: "100%",
}))

export const ButtonsContainer = styled("div")(({ theme }) => ({
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: theme.spacing(5),
    width: "100%",
}))

export const DocumentInfo = styled(L2RDocumentInfo)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(4),
    right: theme.spacing(4),
}))